package org.braunequip.web.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.braunequip.web.util.Theme
import org.jetbrains.compose.web.css.*

/*
    Hero Section
*/
val HeroAlign = CssStyle {
    base {
        Modifier
            .textAlign(TextAlign.Center)
    }
    Breakpoint.MD {
        Modifier
            .textAlign(TextAlign.End)
    }
}

// Greyed out Call to action column on top of truck background.
val CallColumn = CssStyle {
    base {
        Modifier
            .gap(2.cssRem)
            .width(100.percent)
            .backgroundColor(Color.rgba(0,0,0, 0.5.toFloat()))
            .padding(top = 4.cssRem, bottom = 10.cssRem )

    }
    Breakpoint.MD {
        Modifier
            .gap(2.2.cssRem)
            .width(60.percent)
            .backgroundColor(Color.rgba(0,0,0, 0.5.toFloat()))
            .padding(top = 10.cssRem, leftRight = 2.cssRem, bottom = 20.cssRem )
    }
}

// braun trucks background styling
val lineupBg = CssStyle {
    base {
        Modifier
            .background(
                Background.of(
                    image = BackgroundImage.of(url("brauntrucks.jpg")),
                    position = BackgroundPosition.of(CSSPosition.Center),
                    size = BackgroundSize.Cover,
                ),
            )
    }
}

val CTAButtonStyle = CssStyle {
    base {
        Modifier
            .color(Colors.Black)
            .backgroundColor(Theme.PrimaryGreen.rgb)
            .width(200.px)
            .height(80.px)
            .transition(Transition.of("ease-in-out"), Transition.of("all", 0.4.s))
    }
    Breakpoint.MD {
        Modifier
            .margin(top = 4.cssRem)
    }
    hover {
        Modifier
            .color(Colors.White)
            .backgroundColor(Theme.Primary.rgb)
    }
}

/*
    Services Section
*/
val ServiceContainerStyle = CssStyle {
    base {
        Modifier
            .padding(topBottom = 2.cssRem)
            .fillMaxWidth()
            .backgroundColor(Theme.DarkGray.rgb)
    }
    Breakpoint.MD {
        Modifier
            .fillMaxWidth()
    }
}

/*
    Our Partners Section
*/
val PartnersContainerStyle = CssStyle {
    base {
        Modifier
            .padding(top = 2.cssRem, bottom = 6.cssRem)
            .fillMaxWidth()
            .backgroundColor(Colors.White)
    }
    Breakpoint.MD {
        Modifier

    }
}

val PartnerImageStyle = CssStyle {
    base {
        Modifier
            .width(min(600.px, 100.percent - 1.cssRem))
            .height(autoLength)
    }
}

